import { AnyRouter } from '@tanstack/react-router'
import { RouterClient } from '@tanstack/react-router/ssr/client'
import { RouterServer } from '@tanstack/react-router/ssr/server'
import { Suspense } from 'react'

type TanstackRouterProviderProps = {
  router: AnyRouter
}

export default function TanstackRouterProvider({
  router
}: TanstackRouterProviderProps) {
  if (import.meta.env.SSR) {
    return <RouterServer router={router} />
  }

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <RouterClient router={router} />
    </Suspense>
  )
}
